module.exports = __webpack_public_path__ + "static/media/appliances.727afd90.svg";